import { Button, Icon, Modal, Typography } from "@/components/atoms";

interface CancelSoloPlanModalProps {
  open: boolean;
  onClose: () => void;
  onCancel?: () => void;
  isCancelling?: boolean;
}

export const CancelSoloPlanModal = ({ open, onClose, onCancel, isCancelling = false }: CancelSoloPlanModalProps) => {
  const handleConfirmCancel = () => {
    onCancel?.();
  };

  const warningIcon = (
    <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
      <div className="absolute inset-[-4px] rounded-full border-8 border-danger-light" />
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-danger">
        <Icon name="Danger" size="lg" className="text-white" />
      </div>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[480px] lg:w-[480px]" featuredIcon={warningIcon}>
      <div className="flex flex-col">
        <Typography variant="title" className="text-neutral-dark-gray">
          Cancel Solo Plan?
        </Typography>
        <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
          Cancelling your Solo Operator plan will remove this Operator account.
        </Typography>

        {/* Warning box with instructions */}
        <div className="mt-5 rounded-lg border border-neutral-mid-gray p-4">
          <Typography variant="action" className="text-neutral-dark-gray">
            If you would like to keep your driver account, please detach from this Operator before cancelling:
          </Typography>

          <ol className="mt-4 list-decimal space-y-2 pl-5">
            <li>
              <Typography variant="paragraph" className="text-neutral-dark-gray">
                Go to Profile
              </Typography>
            </li>
            <li>
              <Typography variant="paragraph" className="text-neutral-dark-gray">
                Scroll down and select Detach from Operator
              </Typography>
            </li>
            <li>
              <Typography variant="paragraph" className="text-neutral-dark-gray">
                Complete the detachment process
              </Typography>
            </li>
          </ol>
        </div>

        {/* Additional warning text */}
        <Typography variant="paragraph" className="mt-5 text-neutral-dark-gray">
          After detaching, you may join your driver account to another Operator by scanning their QR code or entering their Transport
          Provider Code.
        </Typography>

        <Typography variant="paragraph" className="mt-6 text-neutral-dark-gray">
          If you cancel without detaching, your driver account may be permanently removed.
        </Typography>

        <div className="mt-8 flex w-full flex-col gap-3">
          <Button
            variant="primary"
            size="lg"
            onClick={handleConfirmCancel}
            disabled={isCancelling}
            className="w-full !bg-danger hover:!bg-danger-dark"
          >
            {isCancelling ? "Cancelling..." : "Cancel Solo Plan Subscription"}
          </Button>
          <Button variant="secondary" size="lg" onClick={onClose} disabled={isCancelling} className="w-full">
            Keep Subscription
          </Button>
        </div>
      </div>
    </Modal>
  );
};
